import {Box,Grid,Button,Paper,MenuItem,TextField,Breadcrumbs,Link,Typography,Menu} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSupplierList } from "api/hooks/inventory";
import {  useItemReturnReportList } from "api/hooks/reports";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "moment";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DownloadIcon from "@mui/icons-material/Download";
import { PDFDownloadLink } from "@react-pdf/renderer";
import SupplierReturnDetailReportPdf from "scenes/reports/pdfForms/purchase/supplierReturnDetailReportPdf";
import { currencyFormatter } from "utilities/currencyFormatter";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";

const columns = [
  { label: "Return Date" },
  { label: "Item" },
  { label: "Description", width: 100 },
  { label: "Return Quantity" },
  { label: "Unit" },
  { label: "Cost Price" },
  { label: "Supplier" },
];

export default function SupplierReturnReport({ setIsSuccess }) {
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const user = useSelector((state) => state.authReducer.user);
  const {itemReturnReportList, isLoadingitemReturnReportList, setFilter, setSupplier} = useItemReturnReportList(1,business_branch_id);
  const { supplierList } = useSupplierList(1, business_branch_id);

  const [openExportOptions, setOpenExportOptions] = useState(false);
  const [anchorE1, setAnchorE1] = useState(null);

  const handleClickOpen = (event) => {
    setAnchorE1(event.currentTarget);
    setOpenExportOptions(true);
  };

  const handleClose = () => {
    setOpenExportOptions(false);
  };
  
  const handleChangeSupplierFilter = async (e) => {
    setSupplier(e.target.value);
  };

  const [showFiter, setShowFilter] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().endOf("month").format("YYYY-MM-DD"));

  let report_period = startDate + " to " + endDate

  const handleChangePeriodFilter = async (e) => {
    if (e.target.value === "THIS MONTH") {
      setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("month").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "THIS WEEK") {
      setStartDate(moment().startOf("week").format("YYYY-MM-DD"));
      setEndDate(moment().endOf("week").format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "TODAY") {
      setStartDate(moment().format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
      setShowFilter(false);
    }
    if (e.target.value === "CUSTOM") {
      setShowFilter(true);
    }
  };

  const handleClickFilter = () => {
    setFilter({ start: startDate, end: endDate });
  };

  return (
    <Box>
      <Breadcrumbs sx={{ padding: "20px" }} aria-label="breadcrumb">
        <Link
          underline="hover"
          sx={{ display: "flex", alignItems: "center" }}
          color="inherit"
          onClick={() => navigate("/reports")}
        >
          <AssessmentIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          Reports
        </Link>
        <Typography
          sx={{ display: "flex", alignItems: "center" }}
          color="text.primary"
        >
          <b>Supplier Return Report</b>
        </Typography>
      </Breadcrumbs>
      <Box>
        <Box p="1rem" m="1rem" borderRadius="0.5rem">
          <Grid container spacing={4} className="alignHorizantal">
            <Grid xs={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>REPORT PERIOD:</h4>

                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                  }}
                >
                  <TextField
                    label="PERIOD"
                    select
                    defaultValue="THIS MONTH"
                    size="small"
                    onChange={(e) => {
                      handleChangePeriodFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width:'100%'
                      // m: "10px",
                      // backgroundColor: "white",
                    }}
                  >
                    <MenuItem value="TODAY">TODAY</MenuItem>
                    <MenuItem value="THIS WEEK">THIS WEEK</MenuItem>
                    <MenuItem value="THIS MONTH">THIS MONTH</MenuItem>
                    <MenuItem value="CUSTOM">CUSTOM</MenuItem>
                  </TextField>
                </Paper>
                
                {showFiter ? (
                  <>
                    <Paper
                      sx={{
                        m: "10px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                      }}
                    >
                      <TextField
                        label="Start Date"
                        type="date"
                        defaultValue={startDate}
                        size="small"
                        onChange={(e) => setStartDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          max: endDate,
                        }}
                      />
                    </Paper>
                    
                    <Paper
                      sx={{
                        m: "10px",
                        display: "flex",
                        alignItems: "center",
                        minWidth: 130,
                        maxWidth: 200,
                      }}
                    >
                      <TextField
                        label="End Date"
                        type="date"
                        defaultValue={endDate}
                        size="small"
                        onChange={(e) => setEndDate(e.target.value)}
                        // sx={{
                        //   m: "10px",
                        //   backgroundColor: "white",
                        // }}
                        inputProps={{
                          min: startDate,
                        }}
                      />
                    </Paper>
                    
                  </>
                ) : null}
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    m: "9px",
                  }}
                  onClick={() => handleClickFilter()}
                >
                  FILTER
                </Button>
              </Box>
            </Grid>

            <Grid xs={4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  // m: "4px",
                }}
              >
                <h4>FILTER BY SUPPLIER:</h4>
                <Paper
                  sx={{
                    m: "10px",
                    display: "flex",
                    alignItems: "center",
                    minWidth: 130,
                    maxWidth: 200,
                  }}
                >
                  <TextField
                    label="SUPPLIERS"
                    select
                    defaultValue="all"
                    size="small"
                    onChange={(e) => {
                      handleChangeSupplierFilter(e);
                    }}
                    sx={{
                      minWidth: 50,
                      width:'100%'
                    }}
                  >
                    <MenuItem key={"DEFAULT"} value="all">
                      ALL
                    </MenuItem>
                    {supplierList.map((row, index) => {
                      return (
                        <MenuItem key={index} value={row.id}>
                          {row.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Paper>
              </Box>
            </Grid>
            <Grid xs={2} sx={{ textAlign: "right" }}>
              <Button
                variant="contained"
                onClick={handleClickOpen}
                anchorE1={anchorE1}
                endIcon={<DownloadIcon />}
              >
                EXPORT
              </Button>
              <Menu
                style={{ marginRight: "30px" }}
                anchorEl={anchorE1}
                open={openExportOptions}
                onClose={handleClose}
              >
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  <PDFDownloadLink document={<SupplierReturnDetailReportPdf viewData={{ report_detail: itemReturnReportList, report_period: report_period}}  printedBy={user.first_name + ' ' + user.last_name}/>} fileName={`Supplier Return Report for ${report_period}`}>
                    PDF
                  </PDFDownloadLink>
                </MenuItem>    
                <MenuItem
                  style={{color: "black",margin: "5px 0 5px 0",fontSize: "12px",width: "100px",textWrap: "pretty",borderRadius: "5px",}}
                  onClick={() => {handleClose();}}
                >
                  EXCEL
                </MenuItem>  
              </Menu>
            </Grid>
          </Grid>
        </Box>

        <Box>
          <ReportTable
            columns={columns}
            rows={itemReturnReportList}
            loading={isLoadingitemReturnReportList}
            emptyMessage="No Data found"
            renderRow={(row, index) => (
              <RRow key={row.id} index={index}>
                <RCell>{moment(row.related_product_return.return_date).format("LLL")}</RCell>
                <RCell>{row.related_product.product_name}</RCell>
                <RCell>{row.related_product.description}</RCell>
                <RCell>{row.quantity_returned}</RCell>
                <RCell>{row.related_product_unit.related_business_product_unit.name}</RCell>
                <RCell>{currencyFormatter(parseFloat(row.return_amount))}</RCell>
                <RCell>{row.related_product_return.related_supplier.name}</RCell>
              </RRow>
            )}
          />
        </Box>
      </Box>
    </Box>
  );
}
